module.exports = __webpack_public_path__ + "img/library_ic_bold.720f8db9.svg";